import { schema } from 'normalizr';

export const referralCode = new schema.Entity('referralCodes');
export const referralCodes = [referralCode];
